/** Shared date-range display formatting. Pairs with iso-date.util's
 *  ISO-string primitives — this operates on already-resolved Date
 *  objects and produces the "Jan 5 – Jan 10" style label used across
 *  booking, trips, inbox, host-dashboard, search, and home. */

/** Format a start/end Date pair as a human-readable range, e.g.
 *  "Jan 5 – Jan 10", or with `includeYear`, "Jan 5, 2026 – Jan 10, 2026".
 *  With `yearOnEnd`, the year goes on the end date only ("Jan 5 – Jan 10, 2026"),
 *  unless the range crosses a year ("Dec 30, 2026 – Jan 2, 2027").
 *  Does not collapse same-day or same-month ranges — callers that need
 *  a single-date fallback should handle that themselves. */
export function formatDateRange(
  start: Date,
  end: Date,
  opts?: { includeYear?: boolean; yearOnEnd?: boolean },
): string {
  const withYear: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
  const noYear: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
  const startOpts = opts?.includeYear || (opts?.yearOnEnd && start.getFullYear() !== end.getFullYear())
    ? withYear
    : noYear;
  const endOpts = opts?.includeYear || opts?.yearOnEnd ? withYear : noYear;
  return `${start.toLocaleDateString('en-US', startOpts)} – ${end.toLocaleDateString('en-US', endOpts)}`;
}
